import styled from "styled-components";

import { StyledDropdownContent } from "app/pages/workspace/sales/components/custom-dropdown/DropdownContent/styles";
import { StyledDropdownSearch } from "app/pages/workspace/sales/components/custom-dropdown/DropdownSearch/styles";

export const StyledListsDropdownContent = styled(StyledDropdownContent)`
    top: calc(100% + 5px);
    width: 320px;
    overflow: hidden;

    ${StyledDropdownSearch} {
        .input-container {
            input {
                padding: 20px 16px 20px 0;
            }
        }
    }
`;
